import React from "react";

/**
 * EmptyPage Component
 *
 * A reusable placeholder page component that can be customized for different sections
 */
function EmptyPage({
  title = "Coming Soon",
  description = "This feature is under development and will be available soon.",
  icon = "🚧",
  showBackButton = false,
  onBack = null,
  children = null,
}) {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        {showBackButton && onBack && (
          <div className="flex items-center gap-3 mb-2">
            <button
              onClick={onBack}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Back
            </button>
          </div>
        )}
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      </div>

      {/* Empty State Content */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
        <div className="text-center">
          {/* Icon */}
          <div className="text-6xl mb-6">{icon}</div>

          {/* Title */}
          <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>

          {/* Description */}
          <p className="text-gray-600 max-w-md mx-auto mb-6">{description}</p>

          {/* Custom Content */}
          {children && <div className="mt-6">{children}</div>}

          {/* Coming Soon Badge */}
          <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
            Coming Soon
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyPage;
